<template>
    <highcharts  class="chart w-full h-full" :options="options" :ref="chartId" id="chartId"></highcharts>
</template>

<script>
import {reduceBigNumbers} from '../main.js'
import {numberFormat} from '../main.js'
let data = {}
const moment = require('moment')
    
export default {
    props: ['data', 'chartId'],
    data: function(){
        return {
            options: {
                chart: {
                    type: 'areaspline',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    backgroundColor:'rgba(255,255,255,0)',
                    spacingBottom: 5,
                    marginTop: 20,
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                credits:{
                    enabled: false
                },
                xAxis:[
                
                    {
                    lineColor: 'rgba(255,255,255,0)',
                    title: {
                        text: null
                    },
                    labels: {
                        style:{
                            color:'#768194'
                        },
                        enabled: false
                    },
                    tickWidth: 0,
                    type: 'datetime',
                    },

                    {
                    lineColor: 'rgba(255,255,255,0)',
                    title: {
                        text: null
                    },
                    labels: {
                        style:{
                            color:'#768194'
                        },
                        enabled: false
                    },
                    tickWidth: 0,
                    type: 'datetime',
                    }
                ]
                ,
                exporting:{
                    enabled:false
                },
                yAxis:[{
                    title: {
                        text: '',
                    },
                    // type: 'logarithmic',
                    gridLineColor: '#AFA9A9',
                    labels: {
                        // enabled: true,
                        // formatter: function(){
                        //     return reduceBigNumbers(this.value,0)
                        // }
                    },
                    tickAmount: 4,
                }],
                tooltip: {
                    // enabled:true,
                    // formatter: function() {
                    //     return this.series.name + ' <b>' + numberFormat(this.y) + '</b>';
                    // },
                    enabled:false
                },
                plotOptions: {
                    areaspline:{
                        fillOpacity:.2,
                        lineWidth:3,
                        marker:{
                            enabled:false
                        },
                        shadow: {
                            offsetX: 2,
                            offsetY: 4,
                            opacity: .2,
                            width: 4,
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                series: [
                    
                ]
            }
        }
    },
    methods: {
        updateData(){
            
            let chart = this.$refs[this.chartId].chart;

            for(var i = chart.series.length -1; i > -1; i--) {
                chart.series[i].remove();
            }

            let num = 0,

            colors = ['#4299e1', '#768194']

            for(var serie in this.data){

                chart.addSeries({
                    data: this.data[serie],
                    name: this.data[serie],
                    xAxis: num,
                    color: colors[num]
                })

                num = num +1

            }

        }
    },
    watch: {
        data: {
            handler(a, b){
                this.updateData();
            },
            deep: true
        },
    },
    mounted() {
        this.updateData();
    }
};
</script>
<style lang="css">

    .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

</style>
